import { ArrowUp } from "lucide-react";
import { BRAND, NAV_LINKS, SOCIALS } from "@/content";
import { SocialIcon } from "@/components/SocialIcons";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 bg-card2/60 pb-32 md:pb-12 pt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <span className="inline-block bg-white rounded-xl px-3 py-2 shadow-[0_0_25px_rgba(255,255,255,0.12)]">
              <img src="/images/qt-logo.png" alt="QT 2hype logo" className="h-14 w-auto" />
            </span>
            <p className="mt-4 text-zinc-400 text-sm leading-relaxed">{BRAND.tagline}</p>
            <div className="mt-6 flex gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.name}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${s.name.toLowerCase()}`}
                  aria-label={`QT 2hype on ${s.name}`}
                  className="w-10 h-10 rounded-full glass flex items-center justify-center text-zinc-400 hover:text-volt hover:border-volt/50 transition-colors"
                >
                  <SocialIcon name={s.name} className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="Footer">
            <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-zinc-500 mb-5">Navigate</p>
            <ul className="grid grid-cols-2 gap-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-zinc-400 hover:text-volt transition-colors font-head uppercase tracking-wide">
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <a href="#booking" data-testid="footer-booking-link" className="text-sm text-volt font-head font-bold uppercase tracking-wide">
                  Book Me
                </a>
              </li>
            </ul>
          </nav>

          <div>
            <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-zinc-500 mb-5">Contact</p>
            <a href={`mailto:${BRAND.email}`} className="block text-sm text-zinc-300 hover:text-volt transition-colors">
              {BRAND.email}
            </a>
            <a href={`tel:${BRAND.phone.replace(/[^+\d]/g, "")}`} className="block mt-2 text-sm text-zinc-300 hover:text-volt transition-colors">
              {BRAND.phone}
            </a>
            <p className="mt-4 text-xs text-zinc-600 leading-relaxed">
              Available for clubs, festivals, weddings, corporate and private events worldwide.
            </p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-zinc-600">
            (c) 2018 {BRAND.name}. All rights reserved.
          </p>
          <a
            href="#home"
            data-testid="footer-scroll-top"
            aria-label="Back to top"
            className="w-11 h-11 rounded-full glass flex items-center justify-center text-zinc-400 hover:text-volt hover:border-volt/50 transition-colors"
          >
            <ArrowUp className="w-5 h-5" />
          </a>
        </div>
      </div>
    </footer>
  );
}
